export const viewStylesheet = {
  container: {
    position: "relative",
    width: "100%",
    height: "100%",
    // padding: 10,
  },
  contentContainer: {
    height: "100%",
    padding: 10,
    overflowY: "auto",
  },
  limitedContentContainer: {
    width: "100%",
    // maxWidth: 700,
  },
  vCenter: {
    display: "flex",
    alignItems: "center",
  },
  hCenter: {
    display: "flex",
    justifyContent: "center",
  },
  commandBar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    marginBottom: 10,
  },
} as const;
